var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8398 27.8555C21.3457 27.8555 27.5527 21.6484 27.5527 14.1426C27.5527 6.63672 21.3457 0.429688 13.8262 0.429688C6.32031 0.429688 0.126953 6.63672 0.126953 14.1426C0.126953 21.6484 6.33398 27.8555 13.8398 27.8555ZM13.8398 26.0918C7.22266 26.0918 1.9043 20.7598 1.9043 14.1426C1.9043 7.52539 7.22266 2.20703 13.8262 2.20703C20.4434 2.20703 25.7754 7.52539 25.7891 14.1426C25.7891 20.7598 20.457 26.0918 13.8398 26.0918ZM13.8125 20.6367C14.373 20.6367 14.7148 20.2539 14.7148 19.666V15.0312H19.5C20.0742 15.0312 20.4707 14.7031 20.4707 14.1699C20.4707 13.6094 20.0879 13.2676 19.5 13.2676H14.7148V8.48242C14.7148 7.88086 14.373 7.49805 13.8125 7.49805C13.2656 7.49805 12.9512 7.89453 12.9512 8.48242V13.2676H8.17969C7.57812 13.2676 7.18164 13.6094 7.18164 14.1699C7.18164 14.7031 7.60547 15.0312 8.17969 15.0312H12.9512V19.666C12.9512 20.2402 13.2656 20.6367 13.8125 20.6367Z",
    fill: "#0292DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.24bfba5c117ad75a35a2171de9aecfa4.svg";
export { ForwardRef as ReactComponent };